import { render, staticRenderFns } from "./LuojiaSwarm.vue?vue&type=template&id=5b9bf6cc"
import script from "./LuojiaSwarm.vue?vue&type=script&lang=js"
export * from "./LuojiaSwarm.vue?vue&type=script&lang=js"
import style0 from "./LuojiaSwarm.vue?vue&type=style&index=0&id=5b9bf6cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports